module.exports = __webpack_public_path__ + "img/body-1.4be117dd.png";